import Store from "./Store";
import {Ticket} from "../../model/ticket.model";

export default class TicketStore extends Store<Ticket> {
  protected override name: string = "tickets";

  public markAsRead(ticket: Ticket): void {
    ticket.customer_read_at = new Date();

    this.update(ticket).subscribe((updatedTicket: Ticket) => {
      ticket.customer_read_at = updatedTicket.customer_read_at;
    });
  }
}
